import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  margin-left: -15px;
`;
